import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import logoImg from '../../images/carter-logo.svg';

const Dashheader = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const user = JSON.parse(sessionStorage.getItem('user')) || { name: 'User' };
  const token = sessionStorage.getItem('authToken');

  const handleLogout = () => {
    sessionStorage.clear(); 
    navigate('/'); 
  };

  // Check if current path is NOT /contact or /privacy
  const showDropdown = !['/terms'].includes(location.pathname);

  return (
    <nav className="navbar navbar-expand-lg bg-body-tertiary">
      <div className="container">
        <Link className="navbar-brand" to="/">
          <img src={logoImg} alt="Carter Logo" />
        </Link>

         {showDropdown && token && (
          <div className="dropdown ms-auto">
            <button 
              className="btn btn-secondary dropdown-toggle" 
              type="button" 
              id="userDropdown" 
              data-bs-toggle="dropdown" 
              aria-expanded="false"
            >
              Hi, {user.name ? user.name.charAt(0).toUpperCase() + user.name.slice(1) : ''}
            </button>
            <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="userDropdown">
              <li><Link className="dropdown-item" to="/dashboard">Dashboard</Link></li>
               <li><Link className="dropdown-item" to="/contact">Contact Us</Link></li>
              <li><button className="dropdown-item" onClick={handleLogout}>Logout</button></li>
            </ul>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Dashheader;
